// src/iconMapping.tsx
import React from "react";
import {
  AlertTriangle,
  Award,
  BarChart2,
  Brain,
  Briefcase,
  Calendar,
  CheckCircle,
  ChevronDown,
  Code,
  Copy,
  Database,
  DollarSign,
  Edit2,
  ExternalLink,
  FileText,
  Filter,
  Github,
  GitBranch,
  HardDrive,
  Heart,
  HelpCircle,
  Home,
  Image as ImageIcon,
  Info,
  Layers,
  Lightbulb,
  Link as LinkIcon,
  Linkedin,
  ListChecks,
  Lock,
  Mail,
  MapPin,
  Maximize,
  MessageCircle,
  Minimize,
  Minus,
  Moon,
  MoreHorizontal,
  Move,
  Package,
  PlayCircle,
  PlusCircle,
  Power,
  Puzzle,
  RefreshCcw,
  Save,
  Search,
  Send,
  Settings,
  Share2,
  Shield,
  ShoppingCart,
  Sidebar,
  Smile,
  Star,
  Sun,
  Tag,
  Target,
  ThumbsUp,
  Trash2,
  TrendingDown,
  TrendingUp,
  Twitter,
  UploadCloud,
  Users,
  Video,
  Wifi,
  X,
  Youtube,
  Zap,
  ZoomIn,
  ZoomOut,
  Settings2,
  LayoutGrid,
  List,
  Newspaper,
  ChevronUp,
  UserCheck,
  Rocket,
  ClipboardList,
  Globe,
  Activity,
  MessageSquare,
  Menu,
  Check,
  Wrench,
  Cloud,
  Unlock,
  Archive,
  FileQuestion,
  ListTodo,
  Clock,
  Gift,
  Palette,
  UserCircle2,
  Cpu,
  ShieldAlert,
  UserX,
  TerminalSquare,
  Network,
  ShieldQuestion,
  FlaskConical,
  BarChartHorizontal,
  ShieldCheck,
  BrainCircuit,
  PackageOpen,
  CalendarDays,
  MessagesSquare,
  BookMarked,
  Coins,
  Ticket,
  GitPullRequest,
  CheckSquare,
  Gem,
  MousePointerClick,
  CalendarX,
  CreditCard,
  PieChart,
  Repeat,
  ArrowRightLeft,
  Gavel,
  Umbrella,
  Handshake,
  Eye
} from "lucide-react";
import { jsx } from "react/jsx-runtime";
var DEFAULT_ICON_SIZE = 18;
var iconMapping = {
  // General & UI
  default: Settings,
  settings: Settings,
  cog: Settings,
  settings2: Settings2,
  edit: Edit2,
  info: Info,
  alert: AlertTriangle,
  alerttriangle: AlertTriangle,
  // FIX
  warning: AlertTriangle,
  help: HelpCircle,
  helpcircle: HelpCircle,
  // FIX
  question: HelpCircle,
  plus: PlusCircle,
  add: PlusCircle,
  minus: Minus,
  remove: Minus,
  x: X,
  close: X,
  check: Check,
  checkcircle: CheckCircle,
  // FIX
  checksquare: CheckSquare,
  // FIX
  success: CheckCircle,
  home: Home,
  menu: Menu,
  search: Search,
  filter: Filter,
  list: List,
  listchecks: ListChecks,
  // FIX
  listtodo: ListTodo,
  // FIX
  grid: LayoutGrid,
  layoutgrid: LayoutGrid,
  // FIX
  layout: LayoutGrid,
  externallink: ExternalLink,
  // FIX
  link: LinkIcon,
  copy: Copy,
  share: Share2,
  share2: Share2,
  // FIX
  sharealt: Share2,
  more: MoreHorizontal,
  options: MoreHorizontal,
  chevrondown: ChevronDown,
  // FIX
  arrowdown: ChevronDown,
  chevronup: ChevronUp,
  // FIX
  arrowup: ChevronUp,
  save: Save,
  rocket: Rocket,
  trash: Trash2,
  delete: Trash2,
  upload: UploadCloud,
  uploadcloud: UploadCloud,
  move: Move,
  sun: Sun,
  lightmode: Sun,
  moon: Moon,
  darkmode: Moon,
  lock: Lock,
  locked: Lock,
  unlock: Unlock,
  unlocked: Unlock,
  sidebar: Sidebar,
  maximize: Maximize,
  minimize: Minimize,
  zoomin: ZoomIn,
  // FIX
  zoomout: ZoomOut,
  // FIX
  gift: Gift,
  palette: Palette,
  clock: Clock,
  // Agent & AI Related
  agent: UserCheck,
  ai: Brain,
  brain: Brain,
  braincircuit: BrainCircuit,
  cpu: Cpu,
  intelligence: Brain,
  knowledge: Database,
  database: Database,
  rag: Layers,
  layers: Layers,
  llm: MessageCircle,
  prompt: FileText,
  persona: Smile,
  usercircle: UserCircle2,
  usercog: UserCircle2,
  // FIX
  tool: Wrench,
  wrench: Wrench,
  tools: Settings2,
  automation: Zap,
  workflow: GitBranch,
  context: ClipboardList,
  clipboardlist: ClipboardList,
  // FIX
  clipboardcheck: ClipboardList,
  // FIX
  flask: FlaskConical,
  // Features & Value
  feature: Zap,
  zap: Zap,
  capability: Settings,
  benefit: ThumbsUp,
  thumbsup: ThumbsUp,
  value: DollarSign,
  solution: Lightbulb,
  lightbulb: Lightbulb,
  target: Target,
  goal: Target,
  award: Award,
  star: Star,
  // Content & Media
  demo: PlayCircle,
  play: PlayCircle,
  playcircle: PlayCircle,
  video: Video,
  image: ImageIcon,
  picture: ImageIcon,
  "3dmodel": Package,
  package: Package,
  packageopen: PackageOpen,
  file: FileText,
  filetext: FileText,
  // FIX
  document: FileText,
  news: Newspaper,
  newspaper: Newspaper,
  // Business & E-commerce
  ecommerce: ShoppingCart,
  cart: ShoppingCart,
  shoppingcart: ShoppingCart,
  // FIX
  retail: ShoppingCart,
  sales: TrendingUp,
  barchart: BarChart2,
  barcharthorizontal: BarChartHorizontal,
  analytics: BarChart2,
  performance: Activity,
  activity: Activity,
  trendup: TrendingUp,
  trendingup: TrendingUp,
  trenddown: TrendingDown,
  trendingdown: TrendingDown,
  dollar: DollarSign,
  dollarsign: DollarSign,
  // FIX
  pricing: DollarSign,
  money: DollarSign,
  investment: TrendingUp,
  briefcase: Briefcase,
  users: Users,
  customer: Users,
  audience: Users,
  // Development & Technical
  code: Code,
  api: TerminalSquare,
  sdk: Code,
  integration: Puzzle,
  puzzle: Puzzle,
  network: Network,
  setup: Settings,
  roadmap: Calendar,
  calendar: Calendar,
  calendardays: CalendarDays,
  update: RefreshCcw,
  refreshcw: RefreshCcw,
  // FIX
  refresh: RefreshCcw,
  version: Tag,
  tag: Tag,
  milestone: MapPin,
  mappin: MapPin,
  power: Power,
  plugzap: Power,
  // FIX
  harddrive: HardDrive,
  server: HardDrive,
  tech: Settings,
  gitbranch: GitBranch,
  branch: GitBranch,
  archive: Archive,
  filequestion: FileQuestion,
  // Communication & Social
  contact: Mail,
  mail: Mail,
  email: Mail,
  support: HelpCircle,
  chat: MessageCircle,
  messagecircle: MessageCircle,
  // FIX
  message: MessageSquare,
  messagesquare: MessageSquare,
  // FIX
  messagessquare: MessagesSquare,
  social: Share2,
  community: Users,
  twitter: Twitter,
  linkedin: Linkedin,
  github: Github,
  youtube: Youtube,
  discord: MessageCircle,
  feedback: ThumbsUp,
  send: Send,
  // Impact & Ethics
  impact: Heart,
  heart: Heart,
  socialgood: Heart,
  globe: Globe,
  world: Globe,
  ethical: Shield,
  shield: Shield,
  shieldcheck: ShieldCheck,
  // FIX
  shieldquestion: ShieldQuestion,
  // FIX
  shieldalert: ShieldAlert,
  // FIX
  contribution: DollarSign,
  gavel: Gavel,
  umbrella: Umbrella,
  // Specific integrations
  shopify: ShoppingCart,
  salesforce: Cloud,
  zendesk: MessageSquare,
  // Statuses
  active: Zap,
  beta: FlaskConical,
  paused: BarChartHorizontal,
  archivedstatus: Archive,
  privatedraft: Edit2,
  publiclisted: Eye,
  unlisted: LinkIcon,
  privatelisted: Users,
  connected: Wifi,
  syncing: RefreshCcw,
  error: AlertTriangle,
  needsattention: AlertTriangle,
  completed: CheckCircle,
  inprogress: Clock,
  planned: ListTodo,
  onhold: Clock,
  researching: FileQuestion,
  // Icons for Legal Pages
  bookmarked: BookMarked,
  // FIX
  handshake: Handshake,
  creditcard: CreditCard,
  // FIX
  usercheck: UserCheck,
  // FIX
  userx: UserX,
  // FIX
  coins: Coins,
  ticket: Ticket,
  gitpullrequest: GitPullRequest,
  // FIX
  gem: Gem,
  mousepointerclick: MousePointerClick,
  // FIX
  calendarx: CalendarX,
  // FIX
  piechart: PieChart,
  // FIX
  repeat: Repeat,
  arrowrightleft: ArrowRightLeft
  // FIX
};
var getIcon = (iconName, props) => {
  const cleanIconName = iconName?.toLowerCase().replace(/[-_ ]/g, "") || "default";
  const IconComponent = iconMapping[cleanIconName] || iconMapping.default;
  const defaultProps = {
    size: DEFAULT_ICON_SIZE,
    strokeWidth: 2,
    ...props
  };
  return /* @__PURE__ */ jsx(IconComponent, { ...defaultProps });
};
var renderIcon = (iconNodeOrName, props) => {
  if (React.isValidElement(iconNodeOrName)) {
    const existingProps = iconNodeOrName.props;
    const mergedProps = {
      size: DEFAULT_ICON_SIZE,
      strokeWidth: 2,
      ...existingProps,
      ...props
    };
    return React.cloneElement(iconNodeOrName, mergedProps);
  }
  if (typeof iconNodeOrName === "string") {
    return getIcon(iconNodeOrName, props);
  }
  return getIcon("default", props);
};

// src/hooks/useDebounce.ts
import { useState, useEffect } from "react";
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(
    () => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay]
    // Only re-run the effect if value or delay changes
  );
  return debouncedValue;
}
export {
  getIcon,
  iconMapping,
  renderIcon,
  useDebounce
};
